import {
  GET_TRANSLATIONS,
  GET_TRANSLATIONS_BY_NAME,
  NAVIGATION,
} from '../types';
import { error, success } from '../utils';

export let initialState = {
  getTranslations: {
    isLoading: false,
    isError: false,
  },
  getTranslationByName: {
    isLoading: false,
    isError: false,
  },
  data: { translations: [] },
};

const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case GET_TRANSLATIONS:
      return {
        ...state,
        getTranslations: {
          isLoading: true,
          isError: false,
        },
      };
    case success(GET_TRANSLATIONS):
      return {
        ...state,
        getTranslations: {
          isLoading: false,
          isError: false,
        },
        data: action.payload.data,
      };
    case error(GET_TRANSLATIONS):
      return {
        ...state,
        getTranslations: {
          isLoading: false,
          isError: true,
        },
      };

    case GET_TRANSLATIONS_BY_NAME:
      return {
        ...state,
        getTranslationsByName: {
          isLoading: true,
          isError: false,
        },
      };
    case success(GET_TRANSLATIONS_BY_NAME):
      return {
        ...state,
        getTranslationsByName: {
          isLoading: false,
          isError: false,
        },
        data: action.payload.data,
      };
    case error(GET_TRANSLATIONS_BY_NAME):
      return {
        ...state,
        getTranslationsByName: {
          isLoading: false,
          isError: true,
        },
      };

    case NAVIGATION:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
